export const StringifyError = (error: any) => {
  return process.server
    ? JSON.stringify(error, Object.getOwnPropertyNames(error))
    : error
}
